// The parts' `Ongoing` (what the person can go back to while it goes on, such
// as the call they are in), drawn where every sidebar and the phone's panel
// put it. The box is hidden while no part draws anything (`empty:hidden`), so
// it takes no room then.
import { useMeApp } from "../app/context";
import type { OngoingProps } from "../app/screen-part";

export function OngoingRows({
  shape,
  onGo,
  className = "",
}: OngoingProps & { className?: string }) {
  const { parts } = useMeApp();
  return (
    <div
      className={`flex flex-none flex-col gap-1 empty:hidden ${shape === "icon" ? "items-center" : ""} ${className}`.trim()}
    >
      {parts.map(({ id, Ongoing }) =>
        Ongoing ? <Ongoing key={id} shape={shape} onGo={onGo} /> : null,
      )}
    </div>
  );
}
